<svg class="hidden" width="0" height="0">
  <symbol id="large-cross" viewBox="0 0 8 8">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 3.27273L6.90909 0.363636C7.10992 0.162805 7.43553 0.162806 7.63636 0.363637C7.83719 0.564467 7.83719 0.890078 7.63636 1.09091L4.72727 4L7.63636 6.90909C7.8372 7.10992 7.83719 7.43553 7.63636 7.63636C7.43553 7.83719 7.10992 7.83719 6.90909 7.63636L4 4.72727L1.09091 7.63636C0.890078 7.8372 0.564467 7.83719 0.363637 7.63636C0.162806 7.43553 0.162806 7.10992 0.363636 6.90909L3.27273 4L0.363636 1.09091C0.162805 0.890078 0.162806 0.564467 0.363636 0.363636C0.564467 0.162806 0.890078 0.162806 1.09091 0.363636L4 3.27273Z" />
  </symbol>
</svg>
